import * as actionTypes from 'actions/admin/newsArticles';

const initialState = {
    searchResult: {
        isLoading: false
    },
    searchParameters: {}
};

const newsArticles = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADMIN_NEWS_ARTICLES_SEARCH:
            return { ...state, searchResult: { isLoading: true } };
        case actionTypes.ADMIN_NEWS_ARTICLES_SEARCH_SUCCESS:
            return { ...state, searchResult: action.payload };
        case actionTypes.ADMIN_NEWS_ARTICLES_SEARCH_FAILURE:
            return { ...state, searchResult: { isLoading: false } };
        case actionTypes.ADMIN_NEWS_ARTICLES_SET_SEARCH_PARAMETERS:
            return { ...state, searchParameters: action.searchParameters };
        default:
            return state;
    }
};

export default newsArticles;
